import * as io from "io-ts";
import { withMessage } from "io-ts-types";
import { DateTime } from "luxon";
import t from "../../../../i18n";
import type { AggregationPeriod } from "../../../../domain/aggregation/period";

const durationKeys: {
  [key in AggregationPeriod | "P7D" | "P30D" | "P2M" | "P3W" | "P2Y"]: null;
} = {
  ALL: null,
  CYCLE: null,
  CYCLE_2: null,
  P7D: null,
  P30D: null,
  P2M: null,
  P3M: null,
  P6M: null,
  P3W: null,
  P2Y: null,
  P1Y: null,
  P1M: null,
};
export const Duration = withMessage(io.keyof(durationKeys), () =>
  t("schema.period", Object.keys(durationKeys).join(", ")),
);

export type DurationT = io.TypeOf<typeof Duration>;

export const ISODatetime = io.refinement(io.string, s => DateTime.fromISO(s).isValid);
export type ISODatetimeT = io.TypeOf<typeof ISODatetime>;

export const Range = io.strict({
  from: io.union([ISODatetime, io.number, io.null, io.undefined]),
  to: io.union([ISODatetime, io.number, io.null, io.undefined]),
});
export type RangeT = io.TypeOf<typeof Range>;

export const Period = io.union([Range, Duration]);
export type PeriodT = io.TypeOf<typeof Period>;
